export default "__VITE_ASSET__KUBXgSyN__"